module.exports = __webpack_public_path__ + "img/salud-ninos.395d1e07.png";